export default "__VITE_ASSET__mIRCsqE6__"